const FormUtils = {
  initQuantitySelector: function (
    containerSelector = ".quantity-selector",
    callback
  ) {
    const containers = document.querySelectorAll(containerSelector);

    containers.forEach((container) => {
      const input = container.querySelector('input[type="number"]');
      const minusBtn = container.querySelector(
        ".quantity-btn--minus, .cart-item__quantity-btn--minus"
      );
      const plusBtn = container.querySelector(
        ".quantity-btn--plus, .cart-item__quantity-btn--plus"
      );

      if (!input) return;

      const min = parseInt(input.min) || 1;
      const max = parseInt(input.max) || 99;

      minusBtn?.addEventListener("click", () => {
        const currentValue = parseInt(input.value) || min;
        if (currentValue > min) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          if (typeof callback === "function") {
            callback(input);
          }
        }
      });

      plusBtn?.addEventListener("click", () => {
        const currentValue = parseInt(input.value) || min;
        if (currentValue < max) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event("change", { bubbles: true }));
          if (typeof callback === "function") {
            callback(input);
          }
        }
      });

      input.addEventListener("change", () => {
        let value = parseInt(input.value) || min;
        if (value < min) value = min;
        if (value > max) value = max;
        input.value = value;
        if (typeof callback === "function") {
          callback(input);
        }
      });
    });
  },

  initVariantOptions: function (optionSelector, callback) {
    document.querySelectorAll(optionSelector).forEach((option) => {
      option.addEventListener("click", function () {
        const optionGroup = this.closest("[data-option-group]");
        if (!optionGroup) return;

        optionGroup.querySelectorAll(optionSelector).forEach((o) => {
          o.classList.remove(o.dataset.activeClass || "active");
        });

        this.classList.add(this.dataset.activeClass || "active");

        if (typeof callback === "function") {
          const optionName = optionGroup.dataset.optionName;
          const optionValue = this.dataset.optionValue;
          callback(optionName, optionValue, this);
        }
      });
    });
  },

  serializeForm: function (form) {
    const formData = new FormData(form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) params.append(key, value);
    }

    return params;
  },

  showFormLoading: function (form, message = "Loading...") {
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = message;
    }
  },

  hideFormLoading: function (form) {
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = false;
      if (submitBtn.dataset.originalText) {
        submitBtn.textContent = submitBtn.dataset.originalText;
      }
    }
  },

  displayErrors: function (container, errors) {
    if (!container) return;

    const errorArray = Array.isArray(errors) ? errors : [errors];
    const errorHTML = errorArray
      .map((error) => `<div class="form-error-item">${error}</div>`)
      .join("");

    container.innerHTML = `<div class="form-errors">${errorHTML}</div>`;
    container.style.display = "block";
  },

  clearErrors: function (container) {
    if (!container) return;
    container.innerHTML = "";
    container.style.display = "none";
  },
};

if (typeof module !== "undefined" && module.exports) {
  module.exports = FormUtils;
}
